module.exports = __webpack_public_path__ + "static/media/product emr.2e4a0f6c.jpg";